import {
    buildComplianceRequirements,
    isComplexProduct,
} from './compliance-requirements'
import { complianceRequirementCheckerRegistry } from './requirement-checker-registry'
import {
    complexRequirementChecks,
    requirementStatus,
} from './requirement-checks'

const applyComplexComponentAddons = (requirement, context, settings) => {
    const componentEntries = requirement.componentEntries.map(entry => {
        const scopedContext = {
            ...context,
            product: entry.product,
            includedSubstances: entry.placements.map(placement => placement.container),
            componentConcernSubstances: [],
        }
        const evaluation = complianceRequirementCheckerRegistry.applyAddons({
            ...requirement,
            ...entry,
            checks: entry.checks,
            facts: entry.facts,
            missingProperties: entry.missingProperties,
        }, scopedContext, settings)
        const scipFact = evaluation.facts.find(fact => fact.id === 'scip-number')
        const hideCandidateListCategories = settings.hideCandidateListCategoriesWhenScipProvided === true
            && Boolean(scipFact && scipFact.visible && String(scipFact.value || '').trim())

        return {
            ...entry,
            checks: evaluation.checks,
            facts: evaluation.facts,
            missingProperties: evaluation.missingProperties,
            scipVisible: Boolean(scipFact && scipFact.visible),
            scipRequired: Boolean(scipFact && scipFact.required),
            scipNumber: scipFact && scipFact.value ? String(scipFact.value) : '',
            hideCandidateListCategories,
            status: requirementStatus(evaluation.checks),
        }
    })
    const checks = complexRequirementChecks(
        componentEntries.every(entry => entry.status === 'complete'),
    )

    return {
        ...requirement,
        componentEntries,
        checks,
        status: requirementStatus(checks),
    }
}

const buildComplianceInformationV2Requirements = (context = {}, settings = {}) => {
    const state = context.complianceInformation || {}
    const propertyConfig = state.propertyConfig || {
        map: { list: {}, regulation: {} },
        properties: {},
    }
    return buildComplianceRequirements(
        context,
        state.substanceLists || [],
        propertyConfig,
    ).map(requirement => {
        if (isComplexProduct(context)) {
            return applyComplexComponentAddons(requirement, context, settings)
        }

        const evaluation = complianceRequirementCheckerRegistry.applyAddons(
            requirement,
            context,
            settings,
        )
        const scipFact = evaluation.facts.find(fact => fact.id === 'scip-number')
        const hideCandidateListCategories = settings.hideCandidateListCategoriesWhenScipProvided === true
            && Boolean(scipFact && scipFact.visible && String(scipFact.value || '').trim())

        return {
            ...requirement,
            checks: evaluation.checks,
            facts: evaluation.facts,
            scipVisible: Boolean(scipFact && scipFact.visible),
            scipRequired: Boolean(scipFact && scipFact.required),
            scipNumber: scipFact && scipFact.value ? String(scipFact.value) : '',
            hideCandidateListCategories,
            status: requirementStatus(evaluation.checks),
        }
    })
}

const createComplianceInformationV2Validation = (
    context = {},
    settings = {},
    requirements = null,
) => {
    const loaded = context.complianceInformation
        && context.complianceInformation.loaded === true

    if (!loaded) {
        return { isValid: false, errors: [] }
    }

    if (settings.requireCompleteInformation === false) {
        return { isValid: true, errors: [] }
    }

    const resolvedRequirements = requirements
        || buildComplianceInformationV2Requirements(context, settings)

    return {
        isValid: resolvedRequirements
            .every(requirement => requirement.status === 'complete'),
        errors: [],
    }
}

export {
    buildComplianceInformationV2Requirements,
    createComplianceInformationV2Validation,
}
